import { getLocale } from "../runtime";

const sv_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Tack för din beställning, ${inputs.name}!`
};

const thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_thankyoufororder(inputs)
	return "thankYouForOrder";
};

export { thankyoufororder as "thankYouForOrder" };